import React from 'react';
import Page from "../Page";
import TracingSearch from "./tracing/TracingSearch";
import PageList from "./tracing/PageList";

const Tracing = () => {
    return (
        <Page>
            <div className="mt-4 w-full inline-table">
                <TracingSearch />
                <PageList />
            </div>
        </Page>
    );
};

export default Tracing;